var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowForwardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33881 0.473187L8.82911 6.57474C8.93825 6.68642 8.99996 6.84081 8.99996 7.00219C8.99996 7.16357 8.93825 7.31796 8.82911 7.42965L2.33881 13.5284C2.23478 13.627 2.09776 13.6763 1.95907 13.6651C1.82037 13.6539 1.69186 13.5831 1.60292 13.469L0.792604 12.4413C0.604275 12.2029 0.629992 11.8473 0.850371 11.6425L5.77001 7.1069C5.79874 7.08052 5.81526 7.04208 5.81526 7.00164C5.81526 6.96119 5.79874 6.92275 5.77001 6.89637L0.849851 2.35909C0.74442 2.2606 0.679702 2.12164 0.669782 1.97247C0.6573 1.82304 0.701976 1.67457 0.793644 1.56085L1.60292 0.532625C1.6917 0.41783 1.82037 0.346456 1.95941 0.334869C2.09828 0.323632 2.2354 0.373621 2.33881 0.473187Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIcon);
export default __webpack_public_path__ + "static/media/arrow-forward-icon.b3485a70.svg";
export { ForwardRef as ReactComponent };